<template>
    <div v-if="show && question.isShow" class="question-item">
        <div class="question-title"><i v-if="question.isMust">*</i>{{question.serialNumber}}.{{question.title}}</div>
        <div  v-if="question.note">说明：{{question.note}}</div>
        <img class="qs-img-preview" :src="question.pictureUrl" alt="">
        <div class="question-option-container">
            <span>{{question.scaleConfig.minText}}</span>
            <div class="question-option" v-for="(item,index) in question.options" :key="index">
                <div class="question-option-container">
                    <div @click="selectHandler(item,index)" class="option-title">
                        <i v-if="!item.selected" class="iconfont iconselect-normal"></i>
                        <i v-else class="iconfont iconselect-active"></i>
                        <span :class="{active: item.selected}">{{item.optionTitle}}</span>
                    </div>
                    <div class="option-other">
                        <input type="text" v-model="item.fillContent" v-if="item.allowFill && item.selected">
                        <!--<van-field v-if="item.allowUpload && item.selected" name="uploader">-->
                        <!--<template #input>-->
                        <!--<van-uploader @delete="deleteHandler" multiple :after-read="afterRead" v-model="uploader"-->
                        <!--:max-count="10"/>-->
                        <!--</template>-->
                        <!--</van-field>-->
                        <!--<input @change="getFile" type="file" multiple="multiple" v-if="item.allowUpload && item.selected">-->
                    </div>
                </div>
            </div>
            <span>{{question.scaleConfig.maxText}}</span>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'question-scale',
    props: {
      question: { required: true },
      displaySetting: { required: true },
      jumpSetting: { required: true },
      questionList: { required: true },
      patientId: { required: false },
    },
    data () {
      return {
        currentIndex: null,
        fileList: [],
        uploader: [],
        imageList: [],
        jumpPageNumber: null,
        show: true
      }
    },
    created () {
      this.getAnswer()
      this.getPicture()
    },
    watch: {
      'question.isShow': {
        handler (val) {
          //console.log(val)
          if (!val) {
            this.disabledShowOrHide(this.currentIndex, false)
            this.jumpShowOrHide(this.currentIndex, false)
            this.question.options.map(item => {
              item.selected = false
            })
            this.currentIndex = null
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      selectHandler (item, index) {
        if (item.selected) {
          item.selected = false
        } else {
          this.question.options.forEach(v => {
            v.selected = false
          })
          item.selected = true
        }
        //console.log(this.currentIndex, index + 1)
        if (this.currentIndex) {
          this.disabledShowOrHide(this.currentIndex, false)
          this.disabledShowOrHide(index + 1, true)
          if (this.currentIndex == index + 1) {
            this.disabledShowOrHide(this.currentIndex, false)
            this.jumpShowOrHide(this.currentIndex, false)
          } else {
            this.jumpShowOrHide(index + 1, true)
            this.jumpShowOrHide(this.currentIndex, false)
          }
        } else {
          this.disabledShowOrHide(index + 1, true)
          this.jumpShowOrHide(index + 1, true)
        }
        this.question.value = item
        if (item.selected) {
          this.currentIndex = index + 1
        } else {
          this.currentIndex = null
          this.question.value = ''
        }
      },

      jumpShowOrHide (index, boolean) {
        if (this.jumpSetting.length) {
          if (boolean) {
            //console.log(boolean)
            var arr = this.jumpSetting.filter(item => item.optionId == index)
            arr.forEach(it => {
              this.$store.dispatch('queryQuestionPageListAsync', {
                questionPageResp: {
                  questionInfoId: it.questionId,
                  questionnaireNewId: this.question.questionnaireNewId
                }
              })
                .then(res => {
                  this.jumpPageNumber = res.retValue[0].pageNumber
                  this.$emit('setJump', this.jumpPageNumber)
                })
            })
          } else {
            this.$emit('clearJump')
          }
        } else {
          return
        }
      },
      //兼容处理
      disabledShowOrHide (index, boolean) {
        var disabledList = this.displaySetting.filter(item => item.optionId == index).map(it => {
          return it.questionId
        }).flat(9) //平铺数组 兼容处理
        if(disabledList) {
          disabledList.forEach(v => {
            console.log(v)
            if(this.questionList.find(item => item.id == v)) {
              this.questionList.find(item => item.id == v).isShow = boolean
            }
          })
        }
      },
      deleteHandler () {
        this.imageList = []
        if (!this.uploader.length) {
          this.question.options[this.currentIndex - 1].uploadImage = ''
        } else {
          this.afterRead(this.uploader)
        }
      },
      afterRead (file) {
        if (Object.prototype.toString.call(file) == '[object Array]') {
          file.forEach(v => {
            // v.status = 'uploading'
            this.uploadImage(v.file)
              .then((res) => {
                // v.status = 'done'
                this.imageList.push(res.name)
                this.question.options[this.currentIndex - 1].uploadImage = this.imageList.join(',')
              })
              .catch(() => {
                v.status = 'failed'
              })
          })
        } else {
          // file.status = 'uploading'
          this.uploadImage(file.file)
            .then((res) => {
              // file.status = 'done'
              this.imageList.push(res.name)
              this.question.options[this.currentIndex - 1].uploadImage = this.imageList.join(',')
            })
            .catch(() => {
              file.status = 'failed'
            })
        }
      },
      uploadImage (file) {
        return new Promise((resolve, reject) => {
          let uploadData = {}
          uploadData.file = file
          uploadData.url = file.name
          uploadData.objName = `question/uploadImg/${Math.floor(Math.random()) + new Date().getTime()}`
          this.$store.dispatch('put', uploadData)
            .then(res => {
              if (res.res.status == 200) {
                resolve(res)
              }
            })
            .catch((rej) => {
              reject()
            })
        })
      },

      checkIsFill () {

        if (this.question.isShow) {
          if (this.question.isMust) {
            if (this.question.value && this.question.value != 'null') {
              return true
            } else {
              return false
            }
          } else {
            return true
          }
        } else {
          return true
        }

        // if (this.question.isMust && this.question.isShow) {
        //   if (this.question.value) {
        //     return true
        //   } else {
        //     return false
        //   }
        // } else {
        //   return true
        // }
      },
      saveAnswer () {
        return new Promise((resolve => {
          var params = {
            operatorId: localStorage.getItem('huidrUserId'),
            questionInfo: this.question.id,
            questionnaireNewId: this.question.questionnaireNewId,
            answerInfo: this.question.value ? JSON.stringify(this.question.value) : '',
            id: this.question.patientAnswerInfoId || null,
            patientId: this.patientId || null,
            questionType: this.question.type||null,
          }
            if (this.$route.query.abnormal=='5') {
              params.isRecord  = true
            }else {
              params.isRecord  = false
            }
          if (this.question.patientAnswerInfoId) {
            this.$store.dispatch('updateQuestionAnswer', params)
              .then(() => {
                resolve()
              })
          } else {
            this.$store.dispatch('saveQuestionAnswer', params)
              .then(() => {
                resolve()
              })
          }
        }))
      },
      getPicture() {
        if(this.question.pictureUrl) {
          this.$store.dispatch('getPicture', {url:[this.question.pictureUrl]})
            .then(res => {
              this.question.pictureUrl = res[0]
            })
        }
      },
      getAnswer () {

        this.displaySetting.map(item => {
          if(item.newOptionId) {
            item.optionId = this.question.options.findIndex(_it => _it.id == item.newOptionId) + 1
            return item
          }
        })

        if (this.question.value && this.question.value.optionTitle) {
          var optionIndex = this.question.options.findIndex(item => item.id == this.question.value.id)
          //console.log('optionIndex', this.question.options[optionIndex])
          this.currentIndex = optionIndex + 1
          this.question.options[optionIndex].selected = true
          //console.log(this.question.value.fillContent)
          this.question.options[optionIndex].fillContent = this.question.value.fillContent
          this.disabledShowOrHide(optionIndex + 1, true)
          if (this.jumpSetting.length) {
            //console.log(this.jumpSetting.find(item => item.optionId == optionIndex + 1))
            if (this.jumpSetting.find(item => item.optionId == optionIndex + 1)) {
              var questionId = this.jumpSetting.find(item => item.optionId == optionIndex + 1).questionId
              this.$store.dispatch('queryQuestionPageListAsync', {
                questionPageResp: {
                  questionInfoId: questionId,
                  questionnaireNewId: this.question.questionnaireNewId
                }
              })
                .then(res => {
                  this.jumpPageNumber = res.retValue[0].pageNumber
                  this.$emit('setJump', this.jumpPageNumber)
                })
            }

          }
          this.show = true
          //如果有跳转逻辑
          // this.question.options.find(item => item.id == this.question.value.id).selected = true
        } else {
          this.show = true
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
    @import "questionCommon";


    .question-option-container {
        display: flex;
        .question-option {
            .option-title {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                margin:0 20px;
                span {
                    font-size: 16px;
                }
            }

            .option-other {

            }
        }
    }
</style>